// this is an autogenerated file from DesignSystem/LeadPreview/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_LeadPreview($leadId: uuid!) {
  leads_leads_by_pk(id: $leadId) {
    id
    metadata
    tracking_metadata
    status
    notes {
      id
      notes
    }
    created_at
    updated_at
    location_id
    patient_id
    configuration {
      id
      questions {
        order
        name
        options
        prompt
        id
        subprompt
        type
        required
        status
        external_resource
        metadata
      }
    }
    location {
      id
      name
    }
    patient {
      id
      _id
      heard_from_other
      heard_from_website
      patient_template_referrals {
        id
        text_value
        referral_template {
          id
          type
          free_type
        }
      }
      person {
        id
        _id
        first_name
        last_name
        tx_payers {
          id
          tx {
            id
            tx_plan {
              id
              fee
            }
          }
        }
      }
      appointments(
        limit: 1
        where: {
          appointment_bookings: { state: { _in: ["CHECKED_OUT", "SCHEDULED"] } }
        }
      ) {
        id
        appointment_bookings(limit: 1) {
          id
        }
      }
    }
    analytics(order_by: { created_at: desc }, limit: 1) {
      id
      metadata
    }
  }
}

`